import { useTheme } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import Rectangle from "./Rectangle 790.png";
import { currencyToIndianRsWord } from "../../../utils/helpers";
import Tooltip from "@mui/material/Tooltip";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Property = function Property(props) {
  var _config$projects, _config$deals$darkThe, _config$deals$darkThe2, _config$deals$darkThe3;
  var isMapView = props.isMapView;
  var theme = useTheme();
  var projectId = props.projectId,
    projectName = props.projectName,
    projectDescription = props.projectDescription,
    projectApartmentSize = props.projectApartmentSize,
    projectCity = props.projectCity,
    projectPrice = props.projectPrice,
    projectStatus = props.projectStatus,
    projectBackground = props.projectBackground,
    getProjectLocation = props.getProjectLocation,
    mapViewActive = props.mapViewActive,
    _onClick = props.onClick,
    propertyBackgroundColorWithOverlay = props.propertyBackgroundColorWithOverlay,
    currentPage = props.currentPage,
    projectLocation = props.projectLocation,
    projectType = props.projectType,
    projectLogo = props.projectLogo,
    config = props.config,
    isDosti = props.isDosti,
    appType = props.appType,
    onNavigateToDetail = props.onNavigateToDetail;
  var queryParams = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");
  var history = useHistory();
  var userId;
  userId = queryParams.get("userId");
  var handleDetail = function handleDetail(e, projectId) {
    e.stopPropagation();
    var source = queryParams.get("source");
    var initiateBooking = queryParams.get("initiateBooking");
    if (source === "whatsapp" || source === "chatbot") {
      if (initiateBooking) {
        history.push("/projects/book-a-site-visit?id=".concat(projectId, "&image=").concat(isDosti ? projectLogo : projectBackground, "&name=").concat(projectName, "&city=").concat(projectCity, "&redirect=whatsapp"));

        // history.push({
        //     pathname: '/projects/book-a-site-visit',
        //     state: {
        //         projectId: projectId,
        //         projectBgImage: isDosti? projectLogo : projectBackground,
        //         projectCity: projectCity,
        //         projectName: projectName,
        //         redirect: 'whatsapp'
        //     }
        // });
      } else {
        var _window$reloy_env$cli;
        window.open("https://wa.me/+91".concat((_window$reloy_env$cli = window.reloy_env.client_config.CONTACT_DETAILS) === null || _window$reloy_env$cli === void 0 ? void 0 : _window$reloy_env$cli.WHATSAPP_CHATBOT, "?text=Project%20Name%3A%20").concat(projectName, "%0AProject%20ID%3A%20").concat(projectId));
      }
    } else {
      if (typeof props.onNavigateToDetail === "function") {
        props.onNavigateToDetail(projectId, {
          page: currentPage,
          userId: userId,
          source: source,
          initiateBooking: initiateBooking,
          projectName: projectName,
          projectCity: projectCity,
          projectLogo: projectLogo,
          projectBackground: projectBackground,
          isDosti: isDosti
        });
      } else {
        if (typeof onNavigateToDetail === "function") {
          onNavigateToDetail({
            projectId: projectId,
            userId: userId,
            currentPage: currentPage
          });
        } else if (appType === "winnre") {
          history.push("/myProfile/projects/".concat(projectId));
        } else {
          history.push("/projects/detail?projectId=".concat(projectId).concat(userId ? "&userId=".concat(userId) : "", "&page=").concat(currentPage));
        }
      }
    }
  };
  var mapClickedHandler = function mapClickedHandler(e, projectId) {
    // console.log('MAP VIEW CLICKED');
    e.stopPropagation();
    getProjectLocation(projectId);
    _onClick(projectId);
  };
  var currencyFormating = function currencyFormating(price) {
    if (price >= 10000000) return currencyToIndianRsWord.format(price).slice(0, -2).concat(" Cr*");
    return currencyToIndianRsWord.format(price).slice(0, -1).concat(" L");
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "z-10 ".concat(propertyBackgroundColorWithOverlay ? propertyBackgroundColorWithOverlay : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white"), " w-full flex ").concat(isMapView ? "flex-row " : "flex-col", " cursor-pointer rounded-xl "),
    onClick: function onClick(E) {
      return handleDetail(E, projectId);
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: "h-44 xl:h-44 2xl:h-52 3xl:h-56 \n                      ".concat(isMapView ? "w-[40%] h-44 xl:h-44 2xl:h-52 3xl:h-56" : "w-full h-44 xl:h-48 2xl:h-56 3xl:h-64", " "),
      children: /*#__PURE__*/_jsxs("div", {
        className: "relative",
        children: [/*#__PURE__*/_jsx("img", {
          src: isDosti ? projectLogo : projectBackground || Rectangle,
          alt: "Contemplative Reptile",
          loading: "lazy",
          width: "100%",
          className: "h-44 xl:h-44 2xl:h-52 3xl:h-56 rounded-xl  ".concat(config !== null && config !== void 0 && (_config$projects = config.projects) !== null && _config$projects !== void 0 && (_config$projects = _config$projects.moduleConfig) !== null && _config$projects !== void 0 && _config$projects.QRCodeImage ? "object-contain border-[1.5px] border-gray-200" : "object-cover object-center") // add object-contain for QR code logos
        }), /*#__PURE__*/_jsx("div", {
          className: "absolute top-1 left-3",
          children: /*#__PURE__*/_jsx(Tooltip, {
            title: projectStatus === "READY_TO_OCCUPY" && "Ready To Occupy" || projectStatus === "UNDER_CONSTRUCTION" && "Under Construction" || projectStatus === "NEWLY_LAUNCHED" && "Newly Launched" || projectStatus === "SOLD_OUT" && "Sold Out" || projectStatus === "READY_FOR_FIT_OUTS" && "Ready for Fit Outs",
            arrow: true,
            children: /*#__PURE__*/_jsx("div", {
              className: (projectStatus === "READY_TO_OCCUPY" ? "bg-green-500" : projectStatus === "UNDER_CONSTRUCTION" || projectStatus === "SOLD_OUT" ? "bg-red-500" : " bg-blue-500") + "  flex mt-2 justify-between rounded-md",
              children: /*#__PURE__*/_jsx("svg", {
                className: "m-2 ",
                id: "Group_4",
                "data-name": "Group 4",
                xmlns: "http://www.w3.org/2000/svg",
                width: "18.774",
                height: "15.675",
                viewBox: "0 0 18.774 15.675",
                children: /*#__PURE__*/_jsx("path", {
                  id: "Shape",
                  d: "M17.772,15.675H11.666a1.3,1.3,0,0,1-.547-.182.72.72,0,0,1-.548.182H4.465a1.016,1.016,0,0,1-1-1V11.984H1a1.016,1.016,0,0,1-1-1v-2.6a1.016,1.016,0,0,1,1-1h2.46V4.6H1a1.016,1.016,0,0,1-1-1V1A1.016,1.016,0,0,1,1,0H7.108a1.3,1.3,0,0,1,.547.182A.722.722,0,0,1,8.2,0h6.106a1.016,1.016,0,0,1,1,1V3.691h2.462a1.016,1.016,0,0,1,1,1v2.6a1.016,1.016,0,0,1-1,1H15.31v2.779h2.462a1.016,1.016,0,0,1,1,1v2.6A1.016,1.016,0,0,1,17.772,15.675ZM4.465,12.121a.1.1,0,0,0-.091.091v2.6a.1.1,0,0,0,.091.091h6.106a.067.067,0,0,0,.062-.038.048.048,0,0,0-.016-.053v-2.6a.1.1,0,0,0-.091-.091H4.465Zm7.2-.046a.1.1,0,0,0-.091.091v2.6a.1.1,0,0,0,.091.091h6.106a.1.1,0,0,0,.091-.091v-2.6a.1.1,0,0,0-.091-.091H11.666ZM1,8.385a.1.1,0,0,0-.091.091v2.6A.1.1,0,0,0,1,11.164H7.108a.1.1,0,0,0,.091-.091v-2.6a.1.1,0,0,0-.091-.091H1Zm7.245-.046a.1.1,0,0,0-.091.091v2.6a.1.1,0,0,0,.091.092h6.06a.1.1,0,0,0,.091-.092V8.43a.1.1,0,0,0-.091-.091H8.248Zm3.418-3.691a.1.1,0,0,0-.091.091v2.6a.1.1,0,0,0,.091.091h6.106a.1.1,0,0,0,.091-.091v-2.6a.1.1,0,0,0-.091-.091H11.666Zm-7.2,0a.1.1,0,0,0-.091.091v2.6a.1.1,0,0,0,.091.091h6.061a.1.1,0,0,0,.091-.091v-2.6a.1.1,0,0,0-.091-.091H4.465ZM1,.911A.1.1,0,0,0,.911,1V3.6A.1.1,0,0,0,1,3.691H7.108A.1.1,0,0,0,7.2,3.6V1A.1.1,0,0,0,7.108.911ZM8.2.865A.066.066,0,0,0,8.141.9a.05.05,0,0,0,.016.056v2.6a.1.1,0,0,0,.091.091h6.06a.1.1,0,0,0,.091-.091V.957a.1.1,0,0,0-.091-.092Z",
                  transform: "translate(0 0)",
                  fill: "#fff"
                })
              })
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: " ".concat(isMapView ? "w-[60%] px-4" : "w-full ", " flex flex-col justify-between scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-300"),
      children: /*#__PURE__*/_jsxs("div", {
        className: " pl-2 flex-1 flex flex-col justify-center",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h1", {
            className: "".concat(config.fontTitle, " ").concat(config !== null && config !== void 0 && config.darkMode ? (config === null || config === void 0 || (_config$deals$darkThe = config.deals.darkTheme) === null || _config$deals$darkThe === void 0 ? void 0 : _config$deals$darkThe.text) || "text-primary" : "text-[#3E4B54]", " truncate text-lg font-bold capitalize mt-2"),
            children: projectName
          }), /*#__PURE__*/_jsx("p", {
            className: "".concat(config.fontBody, " text-[14px] ").concat(config !== null && config !== void 0 && config.darkMode ? "text-base-content" : "text-[#838687]", " capitalize italic"),
            children: projectCity
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: config.fontBody,
          children: [/*#__PURE__*/_jsxs("div", {
            className: " ".concat(isMapView ? "w-[60%] lg:w-full xl:w-[80%]" : "w-full ", " flex flex-row justify-between mt-4"),
            children: [/*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-[13px] leading-4 uppercase tracking-wider ".concat(config.fontTitle, " ").concat(config !== null && config !== void 0 && config.darkMode ? (config === null || config === void 0 || (_config$deals$darkThe2 = config.deals.darkTheme) === null || _config$deals$darkThe2 === void 0 ? void 0 : _config$deals$darkThe2.text) || "text-primary" : "text-[#838687]"),
                children: "Starting"
              }), /*#__PURE__*/_jsx("h1", {
                className: " self-end font-bold md:text-[16px]",
                children: currencyFormating(projectPrice)
              })]
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-[13px] leading-4 uppercase tracking-wider ".concat(config !== null && config !== void 0 && config.darkMode ? (config === null || config === void 0 || (_config$deals$darkThe3 = config.deals.darkTheme) === null || _config$deals$darkThe3 === void 0 ? void 0 : _config$deals$darkThe3.text) || "text-primary" : "text-[#838687]"),
                children: projectType == "COMMERCIAL" ? "TYPE" : "Configurations"
              }), projectType == "COMMERCIAL" && /*#__PURE__*/_jsx("h1", {
                className: " self-end font-bold  md:text-[16px]",
                children: "COMMERCIAL"
              }), projectType !== "COMMERCIAL" && /*#__PURE__*/_jsx("h1", {
                className: " self-end font-bold  md:text-[16px]",
                children: projectApartmentSize === "Plot" || projectApartmentSize === "Villa" ? projectApartmentSize : projectApartmentSize + " BHK"
              })]
            })]
          }), /*#__PURE__*/_jsx("button", {
            className: "hidden lg:block \n                                ".concat(mapViewActive === projectId ? " text-blue-500" : "text-[#F59E0B]", " \n                                \n                                ").concat(projectLocation == null && "cursor-not-allowed !text-gray-500") + "text-sm self-center text-right",
            onClick: function onClick(e) {
              mapClickedHandler(e, projectId);
              _onClick(projectId);
            },
            disabled: projectLocation == null,
            children: "View on map"
          })]
        })]
      })
    })]
  });
};
export default Property;